import { HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService } from "src/app/shared/services/data.service";
import {
  ResponseData,
  TeamGroup,
} from "../../../shared/services/teacher.interface";
import { LoaderService } from "src/app/shared/services/loader/loader.service";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-game-settings",
  templateUrl: "./game-settings.component.html",
  styleUrls: ["./game-settings.component.scss"],
})
export class GameSettingsComponent implements OnInit {
  @Input() isDialog: boolean = false;
  @Input() teams: number = 0;
  @Input() questions: number = 0;
  @Input() selectedCategroy: string = null;
  maxLimitTeams: number = 10;
  maxLimitQuestions: number = 12;
  @Output() submission = new EventEmitter();
  groupId: string = sessionStorage.getItem("GCTeamId");
  groupData: TeamGroup = null;
  categoryForm: FormGroup;
  categoryList = [];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private loader: LoaderService
  ) {
    this.categoryForm = this.fb.group({
      teams: [0, [Validators.required, Validators.min(1), Validators.max(10)]],
      questions: [
        0,
        [Validators.required, Validators.min(1), Validators.max(12)],
      ],
    });
  }

  ngOnInit(): void {
    this.getSdgBannerList();
    this.getTeamConfig();
  }

  getSdgBannerList() {
    this.loader.display(true);
    this.dataService.getCategoryPublicFilter().subscribe({
      next: (resp: any) => {
        this.categoryList = resp.data.results;
        this.loader.display(false);
      },
      error: (err) => {
        this.loader.display(false);
        console.error(err);
      },
    });
  }

  get fControl() {
    return this.categoryForm.controls;
  }

  increment(control: AbstractControl) {
    let currentValue = control.value || 0;
    currentValue = Math.min(currentValue + 1, 99);
    control.setValue(currentValue);
  }

  decrement(control: AbstractControl) {
    let currentValue = control.value || 0;
    currentValue = Math.max(currentValue - 1, 0);
    control.setValue(currentValue);
  }

  getTeamConfig() {
    if (this.isDialog && this.groupId) {
      this.loader.display(true);
      this.dataService.getTeamGroup(this.groupId).subscribe({
        next: (res: ResponseData<TeamGroup>) => {
          this.selectedCategroy = res.data.category;
          this.categoryForm.patchValue({
            questions: res.data.number_questions,
            teams: res.data.number_participants,
          });
          // this.questions = res.data.number_questions;
          // this.teams = res.data.number_participants;
          this.loader.display(false);
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
          this.loader.display(false);
        },
      });
    }
  }

  // // Increment function
  // increment(type: string): void {
  //   if (type === 'teams' && this.teams < this.maxLimitTeams) {
  //     this.teams++;
  //   } else if (type === 'questions' && this.questions < this.maxLimitQuestions) {
  //     this.questions++;
  //   }
  // }

  // // Decrement function
  // decrement(type: string): void {
  //   if (type === 'teams' && this.teams > 0) {
  //     this.teams--;
  //   } else if (type === 'questions' && this.questions > 0) {
  //     this.questions--;
  //   }
  // }

  submitQuizConfig() {
    if (this.categoryForm.valid && this.selectedCategroy) {
      this.loader.display(true);
      let quizParams = {
        number_questions: this.categoryForm.controls.questions.value,
        number_participants: this.categoryForm.controls.teams.value,
        category: this.selectedCategroy,
      };
      let api = this.isDialog
        ? this.dataService.patchTeamGroup(this.groupId, quizParams)
        : this.dataService.postTeamGroup(quizParams);
      api.subscribe({
        next: (res: ResponseData<TeamGroup>) => {
          sessionStorage.setItem("GCTeamId", res.data.id);
          this.submission.emit(res.data.id);
          this.loader.display(false);
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
          this.loader.display(false);
        },
      });
    }
  }
}

interface Category {
  name: string;
  id: string;
  image: string;
}
